import { isValidElement, ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import type { RouteType } from 'services/routes/helpers/makeRoute';
import Compose from '../Compose';

const RouterView = ({
  routes,
}: {
  routes: Array<RouteType | ReactElement>;
}) => (
  <Routes>
    {routes.map((route, i) => {
      const key = `route-key-${i}`;
      if (isValidElement(route)) {
        return route;
      }

      return (
        <Route
          key={key}
          // @ts-ignore
          path={route.path}
          element={
            <>
              {/* @ts-ignore */}
              <Compose components={route.middlewares}>
                {/* @ts-ignore */}
                <route.layout>
                  {/* @ts-ignore */}
                  <route.component />
                  {/* @ts-ignore */}
                </route.layout>
              </Compose>
            </>
          }
        />
      );
    })}
  </Routes>
);

export default RouterView;
